export default [
  {
    path: '/promotions/getStatistics',
    name: 'getStatistics',
    meta: {
      title: '促销计划统计',
    },
    component(resolve) {
      require(['COMPONENTS/promotions/getStatistics.vue'], resolve)
    }
  },
]